module.exports = __webpack_public_path__ + "static/sport-relief-c902c4f3170f295c4fd48f239588e634.jpg";